"use strict";
/* eslint-disable no-shadow */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCategoryType = exports.UsageType = exports.ProductUsage = exports.ProductType = void 0;
var ProductType;
(function (ProductType) {
    ProductType["Product"] = "Product";
    ProductType["Bundle"] = "Bundle";
    ProductType["Accessory"] = "Accessory";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ProductUsage;
(function (ProductUsage) {
    ProductUsage["REGULAR"] = "REGULAR";
    ProductUsage["CONSUMABLE"] = "CONSUMABLE";
    ProductUsage["SERVICE"] = "SERVICE";
})(ProductUsage = exports.ProductUsage || (exports.ProductUsage = {}));
var UsageType;
(function (UsageType) {
    UsageType["FRONT"] = "FRONT";
    UsageType["END"] = "END";
    UsageType["ENTIRE"] = "ENTIRE";
})(UsageType = exports.UsageType || (exports.UsageType = {}));
var ProductCategoryType;
(function (ProductCategoryType) {
    ProductCategoryType["PRODUCTS"] = "PRODUCTS";
    ProductCategoryType["FUNCTIONS"] = "FUNCTIONS";
})(ProductCategoryType = exports.ProductCategoryType || (exports.ProductCategoryType = {}));
